export function formatValor(valor, language, mostraPercentual = false) {
    // converte para número
    const num = Number(valor);

    // trata casos não-numéricos
    if (!Number.isFinite(num)) return "-";

    // escolhe quantidade de casas decimais
    const options = {
        minimumFractionDigits: Number.isInteger(num) ? 0 : 2,
        maximumFractionDigits: 2,
    };

    // aplica pontuação pt-BR
    const numeroFormatado = language == "pt" ? num.toLocaleString("pt-BR", options) : num.toLocaleString("en-US", options);

    //const numeroFormatado = num.toLocaleString("en-US", options);


    // acrescenta símbolo de % se solicitado
    return numeroFormatado + (mostraPercentual ? "%" : "");
}